"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findDuplicates = exports.getUniqueIds = void 0;
var models_1 = require("@livv/models");
var uniq_1 = __importDefault(require("lodash/uniq"));
var date_1 = require("../date");
var FIRESTORE_MAX_DISJUNCTIONS = 30;
var UNIQUE_ID_MAX_SIZE = 1000;
/** Remove all non-alphanumerical characters */
var normalizeString = function (number) { return number.toUpperCase().replace(/[^A-Z0-9]/g, ''); };
/** DATA MIGRATION MUST BE DONE IF THIS FUNCTION IS MODIFIED */
var getUniqueIds = function (_a) {
    var e_1, _b;
    var number = _a.number, city = _a.city, performedAt = _a.performedAt, juridictionName = _a.juridictionName;
    var uniqueIds = [];
    var date = (0, date_1.formatDate)(performedAt, 'custom', 'yyyy-MM-dd');
    var cityNormalized = normalizeString(city);
    var juridictionNameNormalized = normalizeString(juridictionName);
    var compositeId = "".concat(juridictionNameNormalized, "_").concat(cityNormalized, "_").concat(date);
    try {
        for (var number_1 = __values(number), number_1_1 = number_1.next(); !number_1_1.done; number_1_1 = number_1.next()) {
            var currentNumber = number_1_1.value;
            if (!number) {
                continue;
            }
            var numberNormalized = normalizeString(currentNumber);
            var compositeIdWithNumber = "".concat(compositeId, "_").concat(numberNormalized);
            // Some decisions have number as a free text and may contains large strings pasted by mistake
            if (compositeIdWithNumber.length > UNIQUE_ID_MAX_SIZE) {
                compositeIdWithNumber = compositeIdWithNumber.slice(0, UNIQUE_ID_MAX_SIZE);
                console.error("Decision number in a decision is too long, it has been truncated to ".concat(UNIQUE_ID_MAX_SIZE, " characters: ").concat(compositeIdWithNumber));
            }
            uniqueIds.push(compositeIdWithNumber);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (number_1_1 && !number_1_1.done && (_b = number_1.return)) _b.call(number_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return uniqueIds.length > 0 ? (0, uniq_1.default)(uniqueIds) : [compositeId];
};
exports.getUniqueIds = getUniqueIds;
/** Returns an empty array if decision is unique or an array of duplicates if found */
var findDuplicates = function (db) {
    return function (uniqueIds) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (uniqueIds.length > FIRESTORE_MAX_DISJUNCTIONS) {
                        console.warn("Decision has too many composite ids. Slicing to 30 first ids.");
                    }
                    return [4 /*yield*/, db
                            .collection(models_1.CollectionName.DECISIONS)
                            .where("uniqueIds", 'array-contains-any', uniqueIds.slice(0, FIRESTORE_MAX_DISJUNCTIONS))
                            .get()];
                case 1: return [2 /*return*/, (_a.sent()).docs];
            }
        });
    }); };
};
exports.findDuplicates = findDuplicates;
//# sourceMappingURL=duplicates.js.map